module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-uli.b457394d.jpg";